/**
 * @generated SignedSource<<26ae5d367b75522c91c878312641c654>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewRedaction_OnboardingAndFlag_rootRelayFragment$data = {
  readonly userPreferences: {
    readonly " $fragmentSpreads": FragmentRefs<"onboarding_issueViewRedaction_RedactionOnboardingSpotlight_user">;
  } | null | undefined;
  readonly " $fragmentType": "ui_issueViewRedaction_OnboardingAndFlag_rootRelayFragment";
};
export type ui_issueViewRedaction_OnboardingAndFlag_rootRelayFragment$key = {
  readonly " $data"?: ui_issueViewRedaction_OnboardingAndFlag_rootRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewRedaction_OnboardingAndFlag_rootRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "ui_issueViewRedaction_OnboardingAndFlag_rootRelayFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraUserPreferences",
      "kind": "LinkedField",
      "name": "userPreferences",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "onboarding_issueViewRedaction_RedactionOnboardingSpotlight_user"
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "92092fd59fe761bb50a7208df52eb315";

export default node;
